"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.YAD2_STARTER_CATALOG = void 0;
exports.YAD2_STARTER_CATALOG = [
    {
        id: 'yad2-bdika-condition-ok',
        title: 'נבדק ונמצא תקין',
        content: 'נבדק ונמצא תקין',
        blockType: 'bdika',
    },
    {
        id: 'yad2-bdika-operation-ok',
        title: 'נבדקה תקינות ההפעלה',
        content: 'נבדקה תקינות ההפעלה',
        blockType: 'bdika',
    },
    {
        id: 'yad2-defect-local-crack',
        title: 'נמצא סדק מקומי',
        content: 'נמצא סדק מקומי',
        blockType: 'defect',
    },
    {
        id: 'yad2-defect-moisture-signs',
        title: 'נמצאו סימני רטיבות',
        content: 'נמצאו סימני רטיבות',
        blockType: 'defect',
    },
    {
        id: 'yad2-cause-natural-wear',
        title: 'בלאי טבעי עקב שימוש',
        content: 'בלאי טבעי עקב שימוש',
        blockType: 'siba',
    },
    {
        id: 'yad2-cause-envelope-water',
        title: 'חדירת מים ממעטפת המבנה',
        content: 'חדירת מים ממעטפת המבנה',
        blockType: 'siba',
    },
    {
        id: 'yad2-required-qualified-repair',
        title: 'נדרש תיקון על ידי בעל מקצוע מוסמך',
        content: 'נדרש תיקון על ידי בעל מקצוע מוסמך',
        blockType: 'recommendation',
    },
    {
        id: 'yad2-required-follow-up',
        title: 'נדרש מעקב ובדיקה חוזרת',
        content: 'נדרש מעקב ובדיקה חוזרת',
        blockType: 'recommendation',
    },
    {
        id: 'yad2-comment-existing-conditions',
        title: 'הבדיקה בוצעה בתנאים הקיימים בנכס',
        content: 'הבדיקה בוצעה בתנאים הקיימים בנכס',
        blockType: 'comment',
    },
];
